//PHONE NUMBERS
export const WHATS_APP_LINK = "555194141188";
export const WHATS_APP_TEXT = "51 99414 1188";
export const WHATS_FLORICULTURA_FK_LINK = "5551998443211";
export const WHATS_FLORICULTURA_MK_LINK = "5551998443211";
